import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  EXTERNAL_FOREIGN_OBJECT_REFERENCE,
  AXIS_TICK_VERTICAL_CONFORT_OFFSET,
  AXIS_TICK_OFFSET,
  AXIS_TICK_HORIZONTAL_PADDING,
} from '../constants';
import { TickContent, ViewImageLink } from '../styles';
import { ImageModal } from '../ImageModal';

export const ChartCustomTick = ({
  x, y, label, imageLink, showImage,
}) => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  return (
    <foreignObject
      x={x - AXIS_TICK_OFFSET}
      y={y - AXIS_TICK_VERTICAL_CONFORT_OFFSET}
      width={AXIS_TICK_OFFSET - AXIS_TICK_HORIZONTAL_PADDING}
      height="60"
    >
      <div xmlns={EXTERNAL_FOREIGN_OBJECT_REFERENCE}>
        <TickContent>
          {label}
          {
            showImage && (
              <>
                <ViewImageLink
                  onClick={() => setIsImageModalOpen(true)}
                >
                  View Image
                </ViewImageLink>
                <ImageModal
                  imageUrl={imageLink}
                  isOpen={isImageModalOpen}
                  setIsOpen={setIsImageModalOpen}
                />
              </>
            )
          }

        </TickContent>
      </div>
    </foreignObject>
  );
};

// proptypes
ChartCustomTick.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  imageLink: PropTypes.string,
  showImage: PropTypes.bool.isRequired,
};

ChartCustomTick.defaultProps = {
  imageLink: '',
};
